import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CarouselListItem } from "../types";
import PremiumBadge from "./PremiumBadge";

const CarouselRow: React.FC<{ item: CarouselListItem }> = ({ item }) => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  const meta = [
    `ID: ${item.id}`,
    item.initiativeName,
    item.order !== undefined
      ? t("editorial.carousels.number-label", { value: item.order })
      : null,
  ]
    .filter(Boolean)
    .join(" | ");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        minWidth: 0,
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: theme.palette.text.primary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {item.name}
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            color: theme.palette.text.primary,
            lineHeight: 1.4,
          }}
        >
          {meta}
        </Typography>
      </Box>

      {item.premium && (
        <PremiumBadge label={t("editorial.carousels.premium") || "Premium"} />
      )}
    </Box>
  );
};

export default CarouselRow;
